var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 16.0015V14.3348C14.6663 13.4507 14.3152 12.6029 13.69 11.9778C13.0649 11.3527 12.2171 11.0015 11.333 11.0015H4.66634C3.78229 11.0015 2.93444 11.3527 2.30932 11.9778C1.6842 12.6029 1.33301 13.4507 1.33301 14.3348V16.0015M19.6663 16.0015V14.3348C19.6658 13.5962 19.42 12.8788 18.9675 12.2951C18.515 11.7113 17.8814 11.2944 17.1663 11.1098M13.833 1.1098C14.55 1.29338 15.1855 1.71038 15.6394 2.29506C16.0932 2.87973 16.3395 3.59882 16.3395 4.33896C16.3395 5.07911 16.0932 5.7982 15.6394 6.38287C15.1855 6.96755 14.55 7.38455 13.833 7.56813M11.333 4.3348C11.333 6.17575 9.84062 7.66813 7.99967 7.66813C6.15872 7.66813 4.66634 6.17575 4.66634 4.3348C4.66634 2.49385 6.15872 1.00146 7.99967 1.00146C9.84062 1.00146 11.333 2.49385 11.333 4.3348Z",
    stroke: "#646D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.84bba5a0bf05a4e4f502f1bb74fb3716.svg";
export { ForwardRef as ReactComponent };